import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import {
    getXeroInvoiceSettingApi,
    getReportXeroInvoicesApi,
    exportInvoicesApi,
    exportInvoiceItemsApi,
} from "../../../../services/xeroInvoice";

import {
    exportXeroInvoiceDetailReportApi,
} from "../../../../services/report";

export const getXeroInvoiceSetting = createAsyncThunk('report/getXeroInvoiceSetting', async (data, { dispatch, }) => {
    const response = await getXeroInvoiceSettingApi(data);
    dispatch(setSettings(response.response))
    return response.response;
});

export const getReportXeroInvoices = createAsyncThunk('report/xeroInvoice/getReportXeroInvoices', async (data, { dispatch }) => {
    const response = await getReportXeroInvoicesApi(data);
    dispatch(setXeroInvoicesData(response.response));
    return response.response;
});

export const exportInvoices = createAsyncThunk('report/xeroInvoice/exportInvoices', async (data, { dispatch }) => {
    const response = await exportInvoicesApi(data);
    return response.response;
});

export const exportInvoiceItems = createAsyncThunk('report/xeroInvoice/exportInvoiceItems', async (data, { dispatch }) => {
    const response = await exportInvoiceItemsApi(data);
    return response.response;
});

export const exportXeroInvoiceDetailReport = createAsyncThunk('report/xeroInvoice/exportDetailReport', async (data, { dispatch }) => {
    const response = await exportXeroInvoiceDetailReportApi(data);
    return response.response;
});

const payoutReportAdapter = createEntityAdapter({});

export const { selectAll: selectPayoutReport, selectById: selectPayoutReportById } = payoutReportAdapter.getSelectors(
    state => state.report
);

const xeroInvoiceReportSlice = createSlice({
    name: 'xeroInvoiceReport',
    initialState: payoutReportAdapter.getInitialState({
        id: null,
        settings: {
            currencies: [],
            types: [],
            source_types: [],
            xero_status: [],
        },
        filters: {
            startDate: null,
            endDate: null,
            partner: null
        },
        xeroInvoicesLists: [],
        xeroInvoicesTableRow: 0,
        xeroInvoicesTotalSummary: null,
    }),
    reducers: {
        setSettings: (state, action) => {
            state.settings.currencies = action.payload.currencies;
            state.settings.types = action.payload.types;
            state.settings.source_types = action.payload.source_types;
            state.settings.xero_status = action.payload.xero_status;
        },
        setFilter: (state, action) => {
            state.filters = action.payload;
        },
        setXeroInvoicesData: (state, action) => {
            state.xeroInvoicesLists = action.payload.data;
            state.xeroInvoicesTableRow = action.payload.total;
        },
    },
    extraReducers: {
        // [getPayoutReport.fulfilled]: payoutReportAdapter.setAll
    }
});

export const {
    setSettings,
    setFilter,
    setXeroInvoicesData,
} = xeroInvoiceReportSlice.actions;

export default xeroInvoiceReportSlice.reducer;